import { NavLink } from "react-router-dom";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  to?: string;
  title?: string;
  isDark?: boolean;
  className?: string;
  textClassName?: string;
  logoLight?: string;
  logoDark?: string;
  size?: "sm" | "md" | "lg";
}

export const BrandLogo = ({
  to = "/",
  title = "anJago",
  isDark,
  className,
  textClassName,
  logoLight = "/favlogo-light.png",
  logoDark = "/favlogo-dark.png",
  size = "md",
}: BrandLogoProps) => {
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const resolvedTheme = theme === "system" ? systemTheme : theme;
  const resolvedIsDark = isDark ?? (resolvedTheme === "dark");

  if (!mounted && isDark === undefined) {
    return <div className={cn("h-8 w-8", className)} />;
  }

  const wrapperTextClassName =
    size === "sm" ? "text-lg" : size === "lg" ? "text-2xl" : "text-xl";

  return (
    <NavLink
      to={to}
      className="flex h-full items-center"
      aria-label="FanJago home"
    >
      <div className={cn("flex items-center gap-0 leading-none", wrapperTextClassName, className)}>
        <img
          src={resolvedIsDark ? logoDark : logoLight}
          alt="FanJago logo"
          className="h-[1.7em] w-[1.7em] object-contain"
        />
        <h2
          className={cn(
            "-ml-2 font-heading font-bold text-sidebar-foreground",
            textClassName
          )}
        >
          {title}
        </h2>
      </div>
    </NavLink>
  );
};
